import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@1823-partners/core/setup';

// No ThemeProvider / CssBaseline here: AppShell's DarkModeProvider supplies both.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
